import { useRef, useState } from "react"
import { useHistory, useParams } from "react-router-dom";

import Title from '@base/Title'
import Toast from '@base/Toast'
import CartoesTableView from "@pages/Escola/Cartoes/componentes/CartoesTableView";

import { ProcessoResolver } from "@helpers/ProcessoHelper";

export const DashboardTratamentoNotas = () => {
  const toastRef = useRef(null);

  const [statusSelecionado, setStatusSelecionado] = useState();
  const [tipoSelecionado, setTipoSelecionado] = useState();
  const [horaUltimoRefresh, setHoraUltimoRefresh] = useState();

  const history = useHistory();

  const params = useParams();
  const processo = ProcessoResolver(params.processo);

  const limparFiltros = () => {
    setStatusSelecionado("");
    setTipoSelecionado("");
  }

  function redirecionarParaPaginaDeConteudo(codigoObjetoPostal) {
    history.push(`/${processo.id}/objetosPostais/${codigoObjetoPostal}`);
  }

  const columns = [
    {label: 'id', name: 'id', hidden: true, key: true},
    {
      label: 'Origem do Cartão',
      name: 'origem',
      func: (objColuna, objLinha) => objColuna ? objColuna.descricao : "",
      key: false
    },
    {label: 'Código', name: 'codigo', key: false},
    {label: 'Aluno', name: 'nomeAluno', key: false},
    {
      label: 'Nota',
      name: 'notaAluno',
      func: (objColuna, objLinha) => <> {objColuna}
          <span>{objLinha.notaCalculada}</span>
      </>,
      key: false
    },
    {
      label: 'Objeto Postal', 
      name: 'numeroObjetoPostal',
      func: (c, l) => l == null ? "--" : <span style={{cursor: 'pointer', textDecoration: 'underline'}} onClick={() => redirecionarParaPaginaDeConteudo(c)}>{c}</span>,
      key: false, 
    },
];

  return (
    <>
      <Toast ref={toastRef}/>
      <Title>Tratamento de Notas</Title>

      <CartoesTableView
        exibeFiltro={false}
        refresh={horaUltimoRefresh}
        exibeFiltroTratamentoNota={false}
        permiteReetiquetar={false}
        permiteDigitarCartao={false}
        permiteEditarCartao={false}
        permiteSubstituirCartao={false}
        permiteAnexarDigitalizacao={false}
        permiteTratarPendenciaNota={true}
        permiteDescartarCartao={false}
        mensagemInformativaAoDescartarCartao={"Ao descartar o cartão a pendência de nota será automaticamente atualizada para 'Resolvida'"}
        colunas={columns}
        processo={processo.id}
        somenteComTratamentoNotaPendente={true}
        filtroStatusTratamentoNota={statusSelecionado}
        filtroTipoTratamentoNota={tipoSelecionado}
        aoAtualizarStatusTratamentoNota={(status, cartoes, setCartoes, filtroStatus) => {
            setHoraUltimoRefresh(new Date());
        }}
        motivosDescarteDisponiveis={() => {
          return [{value: 'TRATAMENTO_NOTA', label: 'Tratamento de Nota'}]
        }}
        aoDescartarCartao={(cartao) => setHoraUltimoRefresh(new Date())}
        aoRestaurarCartao={(cartao) => setHoraUltimoRefresh(new Date())}
        aoLimparFiltro={limparFiltros}/>
    </>
  )
}

export default DashboardTratamentoNotas;
